import { render, staticRenderFns } from "./DonationDetails.vue?vue&type=template&id=73b56c5c&"
import script from "./DonationDetails.vue?vue&type=script&lang=js&"
export * from "./DonationDetails.vue?vue&type=script&lang=js&"
import style0 from "./DonationDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73b56c5c')) {
      api.createRecord('73b56c5c', component.options)
    } else {
      api.reload('73b56c5c', component.options)
    }
    module.hot.accept("./DonationDetails.vue?vue&type=template&id=73b56c5c&", function () {
      api.rerender('73b56c5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DonationModal/DonationDetails.vue"
export default component.exports